export const DUMMY_ROLES = {
  data: {
    array: [
      {code: 'view', id: 10, name: 'view'},
      {code: 'PORTAL_ACTION', id: 11, name: 'Action'},
      {code: 'PORTAL_EVENTLOG', id: 12, name: 'View Logs Event'},
      {code: 'PORTAL_PLAYLOG', id: 13, name: 'View Logs Play'},
      {code: 'PORTAL_PLANNING', id: 14, name: 'View Planning'},
      {code: 'PORTAL_TICKET', id: 15, name: 'Ticket'},
      {code: 'RUNAS', id: 16, name: 'Run As'},
      {code: 'PORTAL_USERMGR', id: 17, name: 'User Management'},
      {code: 'PORTAL_STOREVER', id: 18, name: 'Storever View'},
      {code: 'PORTAL_EXPERT', id: 19, name: 'Advance View'},
      {code: 'PORTAL_PUBLISH', id: 20, name: 'Republish'},
      {code: 'PORTAL_REBOOT', id: 21, name: 'Reboot'},
      {code: 'PORTAL_SRVLOG', id: 22, name: 'Server Logs'},
      {code: 'PORTAL_VIEWUPDATESTATUS', id: 50, name: 'View Player Update Status'},
      {code: 'PORTAL_OPENING', id: 55, name: 'OpeningHours'},
      {code: 'PORTAL_INVENTORY', id: 56, name: 'Inventory'}
    ],
    count: 16
  },
  log: null,
  message: null,
  statusCode: 0,
  version: '1.0.1.18'
};

export const DUMMY_ALLOWED = {
  'statusCode': 0,
  'message': null,
  'data': {
    'array': [
      {'url': null, 'id': 3, 'name': 'Creator'},
      {'url': 'https://dsmanager.storever.com', 'id': 2, 'name': 'DSManager'},
      {'url': 'https://admanager.storever.com', 'id': 4, 'name': 'ADManager'}
    ],
    'count': 3
  },
  'log': null,
  'version': '1.0.1.18',
  'timeToProcess': 'string',
  'cached': false
};

export const DUMMY_ADD_CLIENT = {
  'name': 'AD PROXY Delhaize 2',
  'office': 1,
  'sales': 'c0c06e09-2669-42ce-af33-a0ba7cb82096',
  'server': true,
  'loginLimit': 100,
  'isProspect': true,
  'audio': true,
  'audioSet': {
    'producer': 'd4056091-19ce-431a-8f4f-114c2ef2ff55',
    'product': [1, 2],
    'licence': [1, 2],
    'program': [1, 2],
    'adManager': true,
    'volume': 1,
    'cd': true
  },
  'video': true,
  'videoSet': {'producer': '4647ee78-7584-4036-af80-a5d22f632ebf', 'product': [18, 21, 14], 'widget': [1, 2], 'DSManager': true, 'volume': 2}
};

export const DUMMY_CLIENT_BD_UPDATE = {
  'id': 970,
  'isProspect': false,
  'loginLimit': 100,
  'name': 'aaaws ' + Math.floor((Math.random() * 10000) + 5),
  'office': 1,
  'parentUuid': null,
  'sales': {
    'uuid': 'bf619305-d47d-4edc-84f7-d2a18de0eef3',
  },
  'server': false,
  'services': [
    {
      'applications': [{'id': 4, 'enable': false, 'name': 'AdManager'}],
      'enable': true,
      'id': 1091,
      'name': 'Audio',
      'options': [
        {'cd': false},
        {'licence': [
            {selected: true, canCheck: true, id: 1, name: 'Commercial'},
            {selected: true, canCheck: true, id: 2, name: 'Jamendo'}
          ]},
        {'program': [
            {selected: true, canCheck: true, id: 1, name: 'Tailormade'},
            {selected: true, canCheck: true, id: 2, name: 'Mainstream'}
          ]}
      ],
      'producerUuid': 'd4056091-19ce-431a-8f4f-114c2ef2ff55',
      'products': [
        {id: 12, name: 'CD AUDIO', selected: true, canCheck: true},
        {id: 13, name: 'AUDIO FILES', selected: true, canCheck: true}
      ],
      'serviceID': 1,
      'volume': null
    },
    {
      'applications': [{'id': 2, 'enable': false, 'name': 'DSManager'}],
      'enable': true,
      'id': 1092,
      'name': 'Video',
      'options': [
        {'dsCreator': false},
        {'widget': [
            {id: 1, name: 'Creator', selected: true, canCheck: true}, {id: 5, name: 'Form', selected: true, canCheck: true}
          ]},
      ],
      'producerUuid': '4647ee78-7584-4036-af80-a5d22f632ebf',
      'products': [{id: 12, name: 'CD AUDIO', selected: true, canCheck: true}],
      'serviceID': 2,
      'volume': null,
    }
  ],
  'uuid': '2b30b88f-f143-4f10-a4a0-bc452c4edc31'
};

export const DUMMY_SENDBACKRESULT_CLIENT_BD = {
  'data': {
    'id': 970,
    'isProspect': false,
    'loginLimit': 100,
    'name': 'aaaws ' + Math.floor((Math.random() * 10000) + 5),
    'office': 1,
    'parentUuid': null,
    'sales': {
      'uuid': 'bf619305-d47d-4edc-84f7-d2a18de0eef3',
    },
    'server': false,
    'services': [
      {
        'applications': [{'id': 4, 'enable': false, 'name': 'AdManager'}],
        'enable': true,
        'id': 1091,
        'name': 'Audio',
        'options': [
          {'cd': false},
          {'licence': [
              {selected: true, canCheck: true, id: 1, name: 'Commercial'},
              {selected: true, canCheck: true, id: 2, name: 'Jamendo'}
            ]},
          {'program': [
              {selected: true, canCheck: true, id: 1, name: 'Tailormade'},
              {selected: true, canCheck: true, id: 2, name: 'Mainstream'}
            ]}
        ],
        'producerUuid': 'd4056091-19ce-431a-8f4f-114c2ef2ff55',
        'products': [
          {
            id: 12,
            name: 'CD AUDIO',
            selected: true,
            canCheck: true,
            network: true,
            proxy: true,
            wifi: true,
            cd: true
          },
          {
            id: 13,
            name: 'AUDIO FILES',
            selected: true,
            canCheck: true,
            network: false,
            proxy: false,
            wifi: false,
            cd: false
          },
          {
            id: 14,
            name: 'MM-BOX audio VIDEO 1 OUT',
            selected: true,
            canCheck: true,
            network: true,
            proxy: false,
            wifi: true,
            cd: false
          }
        ],
        'serviceID': 1,
        'volume': null
      },
      {
        'applications': [{'id': 2, 'enable': false, 'name': 'DSManager'}],
        'enable': true,
        'id': 1092,
        'name': 'Video',
        'options': [
          {'dsCreator': false},
          {'widget': [
              {id: 1, name: 'Creator', selected: true, canCheck: true}, {id: 5, name: 'Form', selected: true, canCheck: true}
            ]},
        ],
        'producerUuid': '4647ee78-7584-4036-af80-a5d22f632ebf',
        'products': [
          {
            id: 12,
            name: 'CD AUDIO',
            selected: true,
            canCheck: true,
            network: true,
            proxy: false,
            wifi: true,
            cd: false
          }
        ],
        'serviceID': 2,
        'volume': null,
      }
    ],
    'uuid': '2b30b88f-f143-4f10-a4a0-bc452c4edc31'
  },
  'log': null,
  'message': '',
  'statusCode': 0,
  'version': '1.0.1.19'
};

export const DUMMY_CLIENT_BD_SAVE = {
  'id': 970,
  'isProspect': false,
  'loginLimit': 100,
  'name': 'aaaws ' + Math.floor((Math.random() * 10000) + 5),
  'office': 1,
  'parentUuid': null,
  'sales': {
    'uuid': 'bf619305-d47d-4edc-84f7-d2a18de0eef3',
  },
  'server': false,
  'services': [
    {
      'applications': [{'id': 4, 'enable': false, 'name': 'AdManager'}],
      'enable': true,
      'id': 1091,
      'name': 'Audio',
      'options': [
        {'cd': false},
        {'licence': [
            {selected: true, canCheck: true, id: 1, name: 'Commercial'},
            {selected: true, canCheck: true, id: 2, name: 'Jamendo'}
          ]},
        {'program': [
            {selected: true, canCheck: true, id: 1, name: 'Tailormade'},
            {selected: true, canCheck: true, id: 2, name: 'Mainstream'}
          ]}
      ],
      'producerUuid': 'd4056091-19ce-431a-8f4f-114c2ef2ff55',
      'products': [
        {
          id: 12,
          name: 'CD AUDIO',
          selected: true,
          canCheck: true,
          network: true,
          proxy: true,
          wifi: true,
          cd: true
        },
        {
          id: 13,
          name: 'AUDIO FILES',
          selected: true,
          canCheck: true,
          network: false,
          proxy: false,
          wifi: false,
          cd: false
        },
        {
          id: 14,
          name: 'MM-BOX audio VIDEO 1 OUT',
          selected: true,
          canCheck: true,
          network: true,
          proxy: false,
          wifi: true,
          cd: false
        }
      ],
      'serviceID': 1,
      'volume': null
    },
    {
      'applications': [{'id': 2, 'enable': false, 'name': 'DSManager'}],
      'enable': true,
      'id': 1092,
      'name': 'Video',
      'options': [
        {'dsCreator': false},
        {'widget': [
            {id: 1, name: 'Creator', selected: true, canCheck: true}, {id: 5, name: 'Form', selected: true, canCheck: true}
          ]},
      ],
      'producerUuid': '4647ee78-7584-4036-af80-a5d22f632ebf',
      'products': [
        {
          id: 12,
          name: 'CD AUDIO',
          selected: true,
          canCheck: true,
          network: false,
          proxy: false,
          wifi: false,
          cd: false
        }
      ],
      'serviceID': 2,
      'volume': null,
    }
  ],
  'uuid': '2b30b88f-f143-4f10-a4a0-bc452c4edc31'
};

export const DUMMY_SENDBACKRESULT_GET_CLIENTS = {
  'statusCode': 0,
  'message': null,
  'data': {
    'cName': 'musicmatic',
    'office': 1,
    'sales': {'uuid': 'b82faeb8-6527-4ae3-9e33-acebafe4c385', 'name': 'Hofstoetter'},
    'services': [
      {'serviceID': 1, 'id': 1, 'name': 'Audio', 'enable': true, 'producerUuid': null},
      {'serviceID': 2, 'id': 2, 'name': 'Video', 'enable': false, 'producerUuid': null}],
    'applications': [
      {'serviceID': -1, 'enable': true, 'id': 1, 'name': 'Portal'},
      {'serviceID': 1, 'enable': true, 'id': 4, 'name': 'ADManager'},
      {'serviceID': 2, 'enable': true, 'id': 2, 'name': 'DSManager'},
      {'serviceID': 2, 'enable': true, 'id': 3, 'name': 'Creator'}
    ],
    'uuid': '47c837fe-9e93-4b84-a9f7-966e08b25880',
    'created': '2015-03-27T13:58:10.17+00:00',
    'updated': '2018-07-11T07:29:07.8+00:00',
    'id': 1,
    'name': 'Storever DUMMY',
    'isProspect': true,
    'server': true,
    'loginLimit': 1,
    'products': [
      {'id' : '1', 'name' : 'MMBox', 'selected' : 'false', 'canCheck' : 'false'},
      {'id' : '2', 'name' : 'PTL', 'selected' : 'true', 'canCheck' : 'false'},
      {'id' : '3', 'name' : 'PTL-Offline', 'selected' : 'false', 'canCheck' : 'true'}
    ]
  },
  'log': null,
  'version': '1.0.1.18'
};

export const DUMMY_SENDBACKRESULT_VALIDATION_CLIENT = {
  'statusCode': 0,
  'message': 'name',
  'data': true,
  'log': null,
  'version': '1.0.1.18'
};

export const DUMMY_AUDIO_SERVICE_PRODUCERS_LIST = {
  'statusCode': 0,
  'message': 'name',
  'data': {'array': [], 'count': 0},
  'log': null,
  'version': '1.0.1.18'
};

export const DUMMY_SENDBACKRESULT_MINE = {
  'statusCode': 0,
  'message': null,
  'data': {
    'array': [
      {'uuid': 'd52b1d15-3bb7-4a5d-be84-6d77ed8c3998', 'name': ''},
      {'uuid': '21a38875-d981-41e2-950d-2977aad9e3cc', 'name': 'A. Lange & Söhne (license free) [V2]'},
      {'uuid': '54bdd2af-bc67-4f79-ad98-60704c2b809b', 'name': 'A.T.U. [V2]'},
      {'uuid': 'e87fe049-a4b4-4655-8938-38700f0ae103', 'name': 'A3B CUISINES (PTM) [V2]'},
      {'uuid': 'cfeb1f21-7f3e-4df9-8ac8-6b7183799cef', 'name': 'ABL BOUTIQUE - SAVINEL (PTM) [V2]'},
      {'uuid': 'a211970c-c1c1-4af5-9f93-40e529bbf7d7', 'name': 'Accastillage Diffusion'},
      {'uuid': 'bf37431a-92ba-429c-bb6c-cec1a08b7c5c', 'name': 'AD PROXY Delhaize'},
      {'uuid': '68f1de35-206d-4d06-a944-b59f363f2306', 'name': 'AGATHA [V2]'},
      {'uuid': 'f6017b34-91d4-4a44-b1bd-be6a78e0a958', 'name': 'Agora Presse et Caetera (PTM)'},
      {'uuid': 'dd9981c0-5d28-4e8d-9108-440e695eeb60', 'name': 'Aguirre Newman (ABC Serrano)'},
      {'uuid': '9b226edd-083d-428b-a327-365106c0ecd0', 'name': 'Aldi'},
      {'uuid': 'e5901356-4b14-469a-8879-c2c723e90cd1', 'name': 'Alexander McQueen [V2]'},
      {'uuid': 'a8034484-f1ba-43a0-a12f-a723d89be170', 'name': 'Alpine [V2]'},
      {'uuid': '1aad956d-6844-4246-8f01-30ae4793d6cb', 'name': 'Alvaro Moreno'},
      {'uuid': 'c06210b9-3473-4ad8-9517-a63cc962e02d', 'name': 'ALVO'},
      {'uuid': 'bd70154e-0fa4-4ba6-8d63-ea6150689c99', 'name': 'Amei Food GmbH'},
      {'uuid': '49a7fd37-bb1f-4f20-8c78-143b84e22552', 'name': 'André'},
      {'uuid': 'e0da6a22-edce-43f2-a8ae-c35314d6bdb5', 'name': 'Angelina '},
      {'uuid': '5679cdad-d5ef-4c3b-943d-60cf95f85790', 'name': 'Angelina Jamendo'},
      {'uuid': 'd79852b7-736e-42d8-ba11-de5d73c24fa6', 'name': 'Anouk (PTM) [V2]'},
      {'uuid': '2cd4e30b-6bac-40b6-be2a-bcc63f6ba69f', 'name': 'Anthony Vigneron '},
      {'uuid': 'cd4298ca-49de-4aee-ac77-620689999437', 'name': 'Apollo Service'},
      {'uuid': '88c10aee-ca17-4cd3-9194-d4dddbe5f041', 'name': 'Appels'},
      {'uuid': 'dbd97f6e-c49c-4d74-93b9-136de8d19230', 'name': 'Arko'},
      {'uuid': 'a662b24f-1fb6-42eb-af1b-4eb20c0b64b7', 'name': 'Asobio'},
      {'uuid': '429d5671-b326-413b-906f-221acca22250', 'name': 'Atelier du sourcil'},
      {'uuid': '612e9fc5-99a8-482c-b5e8-623afe3ad166', 'name': 'Atol'},
      {'uuid': '355c0f60-31a3-4ae4-833f-1d7dd4fb97e6', 'name': 'Audemars Piguet [V2]'},
      {'uuid': '505b7057-4d16-4471-bc14-b2a23c2e84ed', 'name': 'AUDI CENTER ZAVENTEM (PTM) [V2]'},
      {'uuid': '5a70799d-9fdd-407d-bfbe-79718d5b121d', 'name': 'Audiovalley'},
      {'uuid': '2c6405f3-4487-4320-b383-7d97b7a023f0', 'name': 'Auto 5'},
      {'uuid': '935c0b6e-3a44-4087-9776-84c6d9a7be47', 'name': 'Autobacs [V2]'},
      {'uuid': '17eb2c89-24d0-414a-84ec-5318fb482bf7', 'name': 'AVA ( papier) [V2]'},
      {'uuid': '568f5a49-b48f-40d9-9242-6259dfd0328c', 'name': 'BAGG (PTM) [V2]'},
      {'uuid': 'efaf9051-0569-412b-9077-ee60ac32e659', 'name': 'Baudouin TEST'},
      {'uuid': 'cb816809-1dea-4d63-8af3-149991a22248', 'name': 'Baudouin01'},
      {'uuid': '7caa72b9-dce1-460b-89fb-d532642bb47e', 'name': 'BCBG México [V2]'},
      {'uuid': 'b801a051-8f4d-4f26-94ae-b4d8b385e8be', 'name': 'BEBE 9 (PTM F) [V2]'},
      {'uuid': '2ea0d088-6649-43b2-8e16-2d8bc37cb89f', 'name': 'BEHRENS And HALTERMANN (PTM) [V2]'},
      {'uuid': '8d40941b-4054-4325-b66d-1cdfaaa59ede', 'name': 'BEST WESTERN (PTM) [V2]'},
      {'uuid': '926e0232-a22e-4b06-a2e6-f76cb5b306f3', 'name': 'Best Worscht in Town'},
      {'uuid': '86d546ff-0c3f-4ec9-a5de-d0caa7fe64e5', 'name': 'BETTENRID '},
      {'uuid': '73a574f9-ab95-4864-82a4-c6346374897c', 'name': 'Betty Barclay'},
      {'uuid': '1c1bbd28-4949-44d6-8824-790085447c18', 'name': 'BiG Fernand'},
      {'uuid': 'e1f68188-7b30-44c3-8b06-8f41c81811e7', 'name': 'Bijouterie Ferret (PTM) [V2]'},
      {'uuid': '7935c369-a064-4c9d-8a63-7d9de10f027e', 'name': 'Birkenstock'},
      {'uuid': 'f51be922-6715-4fb1-b24a-6f1c014de137', 'name': 'Blinkgallery'},
      {'uuid': '64efae8d-b071-4561-9d68-ab246e7ab49a', 'name': 'Blocco 5'},
      {'uuid': 'a7dd7cce-3359-4bdd-8652-876398cb2086', 'name': 'Blucs.Chan'},
      {'uuid': '856bbf03-ec2f-4c42-b173-b9ad0e72deee', 'name': 'BMW Belgium'},
      {'uuid': '203585f4-c6cf-4349-9de1-717c292d55ca', 'name': 'BNP Independants (PTM) [V2]'},
      {'uuid': '0a52ab84-f9a1-4a75-a9d3-603c84c1c609', 'name': 'BNP Paribas Fortis'},
      {'uuid': '9e4e786e-3dfd-42d0-82ab-4fa32b5d1db0', 'name': 'Bodystreet'},
      {'uuid': '333a8ae0-101b-4f29-bdb4-2bfde0036a79', 'name': 'BONOBO'},
      {'uuid': '808a390c-c6d1-4b10-b738-7ecbd188df63', 'name': 'BONSABOR'},
      {'uuid': 'a19d3957-59d1-40dd-85bf-70c0aa9947e4', 'name': 'BORRAR (LIDL LICENSED)'},
      {'uuid': '75b93d8c-af20-448b-b131-70fde6ba1f2b', 'name': 'Botticelli [V2]'},
      {'uuid': 'e23f0502-8de4-4750-a96d-fa483ceb93f0', 'name': 'Brasa Y Leña'},
      {'uuid': 'bf5a9ead-7509-40cb-aae1-90fbbcf76ac1', 'name': 'Brax'},
      {'uuid': 'c1e3fbbe-623a-4940-bffa-04a907a353f3', 'name': 'Bree'},
      {'uuid': '64412747-28a9-4710-856f-5af02cc54e02', 'name': 'BREGUET [V2]'},
      {'uuid': '61b5d5af-747c-42d1-8fd4-a08d16ed4fc0', 'name': 'Breuninger '},
      {'uuid': '2c3680d1-83d4-4ab6-9e8f-01db7e2605b1', 'name': 'BRICOCENTRO  (PTM) [V2]'},
      {'uuid': '4a652cf2-40b6-48a9-bc82-93b78db19106', 'name': 'Bricoking'},
      {'uuid': 'b6bf824d-7ba7-4e42-9616-671450821d95', 'name': 'Brioche Doree'},
      {'uuid': '5c4def27-2b97-417a-842c-fe774e34ce5c', 'name': 'Brioche Doree Chine'},
      {'uuid': '39a4ee04-59dc-4a7c-a6ca-4372c0b7bd8a', 'name': 'Brochettes and Cie [V2]'},
      {'uuid': 'c4af9216-8083-42fb-8aa8-893e74c2af23', 'name': 'Bureau Paris [V2]'},
      {'uuid': '0179d0c8-7148-41a5-9566-a9dd323adca0', 'name': 'But [V2]'},
      {'uuid': 'cc9fbcad-f4b0-43b8-a4a9-bbd88b95c07a', 'name': 'C and A [V2]'},
      {'uuid': 'aec1439e-5ec7-4659-875b-4a5c1420bfcf', 'name': 'C and A China'},
      {'uuid': '64f744bc-5983-4ca3-9d47-89038523465e', 'name': 'Cache-Cache China'},
      {'uuid': 'b46882be-9d95-4619-8a93-9800f4a21816', 'name': 'Caffe Ritazza'},
      {'uuid': 'b5a9aab6-75d9-481f-8a00-f6b5dfc965cb', 'name': 'CAFFE RITAZZA AIRPORT (PTM) [V2]'},
      {'uuid': '9a86b096-1f79-46a1-8b05-d2ce943da2ee', 'name': 'Caffe Ritazza UK'},
      {'uuid': '6eea2bcb-d0c3-45a3-aeaa-1bca79bc0bf7', 'name': 'Calzárea (PTM) [V2]'},
      {'uuid': 'a88b3040-8f58-4192-ae4b-82b3eeb32b27', 'name': 'Camaieu'},
      {'uuid': '6254891f-885f-4a4d-ac78-85867781d4e4', 'name': 'Camaieu JAMENDO'},
      {'uuid': '23fb45cf-211a-4c44-9fd1-4398d4cbf8dd', 'name': 'Cameleon (PTM) [V2]'},
      {'uuid': 'c532c012-c073-41ee-9356-318264edc239', 'name': 'Camino A Casa'},
      {'uuid': '36c799fc-96f6-4585-8f5f-66cb21cb3431', 'name': 'Carglass'},
      {'uuid': '7a913e0e-c4d5-4707-83b3-6717c947e817', 'name': 'Carl Video Room'},
      {'uuid': '54fc4994-087c-4057-91f5-0ce1f6d35858', 'name': 'Carol'},
      {'uuid': '21253fd5-d55c-4a87-ac05-90ab7be07e8b', 'name': 'Carolina Boix'},
      {'uuid': 'b34ca518-81c3-4d3b-9ef5-696831cac343', 'name': 'Carrefour Express Spain'},
      {'uuid': '4b766282-4358-4616-9b49-e4fa2af71728', 'name': 'Carrefour Property'},
      {'uuid': 'c3bccff8-0a3e-42c5-b6cb-4dcc2d144b15', 'name': 'Cartier'},
      {'uuid': 'cfaf8cd0-92a6-4966-81fd-e691f2dc591a', 'name': 'Casa Del Libro '},
      {'uuid': '5bc7ed9c-36cf-4916-9da0-4003e7860d12', 'name': 'CASA VIVA'},
      {'uuid': '7da68684-281c-428c-a11d-c1505a36b466', 'name': 'Casino de SPA (PTM) [V2]'},
      {'uuid': 'd188e3fa-c930-42a7-a908-610341bafefe', 'name': 'Cassis'},
      {'uuid': 'bb3be313-39e1-40aa-bac9-e47c9b153494', 'name': 'Cassis-Paprika [V2]'},
      {'uuid': 'be9ec876-2110-4f88-b4dd-ec62774d4d8f', 'name': 'Cecil (PTM) [V2]'},
      {'uuid': '6f5dd086-c310-4fd6-b856-bfc204303058', 'name': 'Centro Comercial en España (PTM F) [V2]'},
      {'uuid': '263674b0-8769-422f-962e-859aecf3fc04', 'name': 'Century Ginwa Plaza'},
      {'uuid': '88ef4723-bd5f-49db-8482-2ef1ec9baabb', 'name': 'Champion'},
      {'uuid': '69f19d48-1ac9-423d-b28b-01ddde560a5b', 'name': 'Charles and Keith'},
      {'uuid': 'fe9b3dcd-ebd0-4009-9782-be7309b516dd', 'name': 'Charles Vögele'},
      {'uuid': '20aa74c2-de45-41b0-9eba-9eaea948febd', 'name': 'Chin'},
      {'uuid': 'b312c39f-ab01-48a4-97f7-2248623bd5a0', 'name': 'China librairy'},
      {'uuid': '33c67b01-2aea-4630-9834-7c254ff0ea73', 'name': 'Chloé'},
      {'uuid': '9619b8fb-4618-4d6e-96d9-53b2fb710e40', 'name': 'CityJet Limited'},
      {'uuid': 'd997177f-10d9-4e74-8ebe-873098376f2b', 'name': 'Clever Fit GmbH'},
      {'uuid': 'da1e5220-03a6-4443-a4c2-125e170415e0', 'name': 'Club [V2]'},
      {'uuid': '7cadd139-aa2c-44fa-bf11-068843654226', 'name': 'Cochet-Swarovski'},
      {'uuid': '5f610f3b-c5d2-4496-b83a-b08630756b2a', 'name': 'Coiff and Co'},
      {'uuid': '4ffb5cdb-d72e-41ed-8fad-59de3dda26b1', 'name': 'COLOVE'},
      {'uuid': '00303a13-5597-4e9c-aaf1-b45291083ae6', 'name': 'Confo Depot'},
      {'uuid': '5d6c845e-52f9-4079-8bbc-daac403fdab8', 'name': 'Cool Play'},
      {'uuid': '2e2f0f0b-045f-4994-8e66-cfeb54349082', 'name': 'Coolway'},
      {'uuid': 'ee5b9861-0507-48c5-a67f-18f352e16d3b', 'name': 'Corné Port-Royal'},
      {'uuid': 'f258b49c-2633-4da9-b7a6-567eb31df7b8', 'name': 'CORNÉ PORT-ROYAL Linthout (PTM) [V2]'},
      {'uuid': '35dff036-8362-437f-8032-0aa1edfb6749', 'name': 'Cosmoparis'},
      {'uuid': 'dc3fbed2-9517-4223-abaf-45af3fd376a3', 'name': 'Courir'},
      {'uuid': '76fd2e1a-e80a-40d4-ae39-6d58c6166dbc', 'name': 'Credit Mutuel - Arkea'},
      {'uuid': '55e531a9-85db-4bcf-b612-ebfdf1b7ffc9', 'name': 'Cuisines Plus'},
      {'uuid': 'ef6508df-d6d7-479a-a27a-713c3759cf04', 'name': 'Dafy [V2]'},
      {'uuid': '838b5917-ecf7-4c4a-b59e-53622d0b1632', 'name': 'Dalbe'},
      {'uuid': 'ec4af025-1ac2-45bc-8149-2d2d0af90913', 'name': 'Dandara [V2]'},
      {'uuid': '1552cb84-2969-4ed1-a907-26b1dfb47684', 'name': 'Daniel Espinosa'},
      {'uuid': '2988fe4c-4faa-46f8-9945-3aea818e7635', 'name': 'DAPHNE'},
      {'uuid': '8859e6f6-c195-4efb-8ad9-76f1af8cdf2d', 'name': 'Daphne Pilot'},
      {'uuid': '1bdffdad-12fa-4ca5-8477-8e2594ff16fb', 'name': 'DAYADAY [V2]'},
      {'uuid': 'b1db79b0-abfb-4a6d-b71a-e66357397761', 'name': 'Dazzle'},
      {'uuid': '47d51cbd-268e-4ecb-a08b-b5d7d0b31a90', 'name': 'DCI '},
      {'uuid': '327da324-e8d3-4ab5-b71e-c0321b50e7e2', 'name': 'Degussa '},
      {'uuid': '7d154ad8-b507-4857-bb69-df2f2ef19cac', 'name': 'Delhaize'},
      {'uuid': '55ad99c3-411f-427d-ae91-4e3855ac928f', 'name': 'DeliFrance'},
      {'uuid': '7d9f8bde-1179-470f-8c5d-6fe250becce1', 'name': 'Délitraiteur [V2]'},
      {'uuid': 'd2410182-72d1-4513-a6ec-1886114fc3e7', 'name': 'Delvaux'},
      {'uuid': 'e04836f5-c290-4fab-826e-1cd56e71a818', 'name': 'Dessange'},
      {'uuid': 'fd5f245c-da15-4322-a7f8-a805394d5851', 'name': 'Detlev Louis'},
      {'uuid': 'f2898d24-6eff-4a0d-b687-b10187233b8f', 'name': 'Devianne [V2]'},
      {'uuid': '79d5f019-a2e6-42da-92bf-131be1a6a765', 'name': 'Di [V2]'},
      {'uuid': 'ec3582d2-03ba-4aea-a7d2-a8196fa7a579', 'name': 'Dimattina Coffe'},
      {'uuid': 'ef9127c3-21bc-4d67-91d0-8e20f878e96a', 'name': 'DIOGO LOPES'},
      {'uuid': 'd1414087-9edc-41dd-820f-9810e1678c10', 'name': 'Distri Center'},
      {'uuid': '82a93715-1790-42cf-b798-d9c82af0bb9e', 'name': 'DPAM - JAMENDO'},
      {'uuid': '6753651e-56d1-42f8-aabd-450236a5e248', 'name': 'DreamLand [V2]'},
      {'uuid': '03283962-55c6-4868-aacd-25f009650fd7', 'name': 'DS PSA Chine'},
      {'uuid': '65b90407-5619-461a-b912-688a68780024', 'name': 'Du Pareil Au Meme'},
      {'uuid': 'a3df8179-a433-4aeb-8962-a9230b442c23', 'name': 'Dunkin Donuts'},
      {'uuid': '7f0ecbe9-3255-401c-be24-9f6cfc0a76dd', 'name': 'E5 Mode'},
      {'uuid': '5ae424b1-539e-4c02-9da7-6d6e9c75178c', 'name': 'easyApotheke [V2]'},
      {'uuid': 'e4bcfac6-966a-41b2-b628-09c7b3c01d3d', 'name': 'El Ganso'},
      {'uuid': 'fae73b18-d001-4139-aa0a-79e909be8f79', 'name': 'ELEMENT FRESH'},
      {'uuid': 'a018b5a8-134d-4733-9f56-34dbbc1af7db', 'name': 'Elior (PTM) [V2]'},
      {'uuid': '0e9fc54f-ac81-425a-a436-475b38abe413', 'name': 'Emilie Video Room'},
      {'uuid': '8eaf61d6-b7e0-4d3b-9391-bca9e2d808f4', 'name': 'Emilio Adani (Jamendo)'},
      {'uuid': '4ce2cb3b-b9d2-46bb-9990-6e231c0e2578', 'name': 'Emilio Adani (Licensed)'},
      {'uuid': 'f1bcb02e-b97f-4824-b44f-302b66f7fb84', 'name': 'EMOI'},
      {'uuid': '5738ca8c-17cd-49cf-8e7d-105c65f9ac86', 'name': 'Emwa [V2]'},
      {'uuid': 'b569c215-d3e5-415a-bfbd-1d793756d221', 'name': 'Engbers'},
      {'uuid': 'c8110a22-5537-4067-969a-f5e0e1a8fea2', 'name': 'Eres'},
      {'uuid': 'fda17d75-3289-4f05-9496-e4d6e0f40daf', 'name': 'Esquires Coffee'},
      {'uuid': 'd8dde4a6-2801-4f69-898a-4bbfde9666ec', 'name': 'Etam (China)'},
      {'uuid': '29a87d56-4478-4bad-b045-17b7f99cd139', 'name': 'Etelecom'},
      {'uuid': '5a5da28b-e396-49ac-8dd4-4ac33bcd183f', 'name': 'Eterna'},
      {'uuid': 'b4296afe-a9e9-4c32-9b18-df6b3c5c61be', 'name': 'EuroKitchen = Kovera (PTM) [V2]'},
      {'uuid': '2e902ed5-3249-4add-94fd-26dab5a2ff01', 'name': 'Euromaster'},
      {'uuid': '1370892c-6c03-4f1d-b67b-4ff3327b6f0c', 'name': 'EVISU'},
      {'uuid': 'fcf526e5-cd56-4f38-a8d7-cd4b7898766d', 'name': 'Exki'},
      {'uuid': '0e9964cc-5288-4c85-9a4a-e665243665d0', 'name': 'Exotic Sun'},
      {'uuid': 'cf13259d-7727-40ac-9039-4ec8bc750fcc', 'name': 'Exotic Sun (PTM) [V2]'},
      {'uuid': 'e257151d-12e7-4653-b971-082c2408c0c3', 'name': 'Express'},
      {'uuid': 'cbc2f1de-ef10-4aca-ab2d-2fb2ee048476', 'name': 'Express New'},
      {'uuid': '70f7e032-b902-495a-90ce-8b8d4798dd77', 'name': 'Faconnable'},
      {'uuid': 'a0f7d67f-2905-4863-b9c3-284e9888e5c0', 'name': 'FAGUO (PTM) [V2]'},
      {'uuid': '0c93fe5a-0913-4d3d-9017-19f289358aee', 'name': 'Falke'},
      {'uuid': 'ae9ec0ad-81d6-4bcb-b69f-3645953b4e55', 'name': 'Familia [V2]'},
      {'uuid': '7c8dfb08-8049-459d-99b8-35616e967ce5', 'name': 'FERRETTI PILOTO'},
      {'uuid': 'eb4be19f-62ab-4876-98d6-9194fdad5f09', 'name': 'Ferrokey (PTM) [V2]'},
      {'uuid': '93fa2f44-9974-4b0e-b3d8-74e8c9c894f2', 'name': 'Firelé (ex-Estilogie-Muys)'},
      {'uuid': '3ae8a0b4-801c-46dc-b8bb-f513bb9a369d', 'name': 'Fitness First Hong Kong'},
      {'uuid': 'c21140c1-0135-489d-bf48-89f661c4fdbb', 'name': 'Florentia Village BELLA VITA'},
      {'uuid': '58633ea7-201e-4265-a385-c628aa0523c1', 'name': 'Florentia Village Customer Service'},
      {'uuid': '39103fc2-d9eb-4ad7-8e7e-61b65d95d65e', 'name': 'Florentia Village Kids'},
      {'uuid': '243fefe4-7b5d-4fa4-a3ea-3aec75158098', 'name': 'Florentia Village Shopping Area'},
      {'uuid': '18eab16c-57df-4942-8226-e04d88f55754', 'name': 'Florentia Village VIP Lounge'},
      {'uuid': '94df0ece-a77e-43dd-a317-7df7349722e7', 'name': 'Flux Jamendo'},
      {'uuid': '1ad246e8-7ee5-4c39-8be6-5da39af12398', 'name': 'FOODMAKER'},
      {'uuid': 'efd501c6-5a50-4018-808c-d6b941a1e857', 'name': 'Ford Deutschland (PTM) [V2]'},
      {'uuid': '09f60e9d-de65-458c-a8d5-500ef17593b0', 'name': 'Formul'},
      {'uuid': '0ef3970e-0f58-443c-bfb8-b9b688ce36be', 'name': 'Fossil (France)'},
      {'uuid': 'd20de9cf-0a12-4691-9869-789977357ecb', 'name': 'Fossil (Germany)'},
      {'uuid': 'a22713ec-5cbe-4248-920c-3613b28b0d6a', 'name': 'Fossil (Music)'},
      {'uuid': 'e6e2adac-4a42-4ba2-8f55-067e973ce186', 'name': 'FOSSIL (Norway)'},
      {'uuid': '9a4b24d6-edf6-46f6-be29-49b89ababa42', 'name': 'Fossil (Spain)'},
      {'uuid': '5a9463b5-2d22-47da-b0d7-d55764c8e214', 'name': 'Fossil (Switzerland)'},
      {'uuid': '21a4bb23-9f14-46fa-93e6-98e3d24ab2a2', 'name': 'Fossil (UK)'},
      {'uuid': '599a00cf-7f93-4b6b-ad63-fc4ff6c704d0', 'name': 'Franck Provost'},
      {'uuid': 'c98d3db4-b810-4c69-9f0b-6f25d5f34805', 'name': 'GATSU GATSU (PTM) [V2]'},
      {'uuid': '4b80f575-a654-4942-b365-6d7919a1d1ba', 'name': 'GB'},
      {'uuid': '68780864-13fb-4a8c-8788-f2390c1b0403', 'name': 'Générale pour l Enfant (PTM F) [V2]'},
      {'uuid': 'd13010b0-529b-4d60-b04d-5d20929b8ec6', 'name': 'George Gina & Lucy'},
      {'uuid': '120f4562-f44e-4d35-9d6e-d61d2274c875', 'name': 'GiFi'},
      {'uuid': '5c540272-dae9-4f40-97f4-bcc17e541392', 'name': 'Glashütte'},
      {'uuid': '188b9ad7-255b-4afe-9668-a5fa72b3055a', 'name': 'Godiva [V2]'},
      {'uuid': 'fd6e8356-d830-4a19-ba8f-1ff8ae2c43ec', 'name': 'Golfino'},
      {'uuid': 'c003d987-f07c-49a4-9d8f-bef4830c8ecd', 'name': 'Grain de Malice [V2]'},
      {'uuid': '5a3d97de-258c-48b9-aea1-342a1244e1a5', 'name': 'GRAND COMPTOIR (PTM) [V2]'},
      {'uuid': '7fd5960f-3c7f-431d-8cb8-451121df9a36', 'name': 'Guapa'},
      {'uuid': '877322d6-363c-4000-857a-886d9b2b9f73', 'name': 'Gui Ren Niao'},
      {'uuid': '4ffeb9e6-5e30-4662-b6f8-96cef8b49707', 'name': 'HALLE - Winkelstraat'},
      {'uuid': 'd5842200-cbe4-4d7d-933c-bddc8c5d7bf5', 'name': 'Hammer Heimtex'},
      {'uuid': 'e9ab90c6-b225-413d-aa67-9410359531a2', 'name': 'Hardy Hardy'},
      {'uuid': '06a11c90-8103-48f2-a7a0-b4ffb61260cd', 'name': 'Hellner Moden (PTM) [V2]'},
      {'uuid': 'd4a213e3-d015-475f-b523-856c3af3df92', 'name': 'Hema'},
      {'uuid': 'a97db147-91be-42e5-9d4e-4f0fc27401e2', 'name': 'Hinos'},
      {'uuid': '14450537-d320-4bee-94f6-48e394606fa8', 'name': 'HIT NL ROCK YOU'},
      {'uuid': 'cc1f9555-666a-4cfe-b436-b7a8410167fa', 'name': 'Home Market'},
      {'uuid': 'c7a7d2ea-e013-45ff-8421-e470c34d1f41', 'name': 'Home Market(Licensed)'},
      {'uuid': '0a859aaa-7e6a-4b8b-bbf6-85e5b2b97c37', 'name': 'Homes Up'},
      {'uuid': '3a146e63-5f70-464e-96f3-7cd484e3ebd9', 'name': 'HOTEL CLARANCE (PTM) [V2]'},
      {'uuid': '647f49e6-a22d-4ec7-89bf-0dd6ffa85587', 'name': 'Hour Passion [V2]'},
      {'uuid': '2d32696a-0222-428b-a956-a533b03f3972', 'name': 'Huber'},
      {'uuid': 'a5952924-ec4e-477e-8f54-a89833cd342b', 'name': 'Huber Shop'},
      {'uuid': '7c6edb1b-a946-4d7f-ad41-cd18ff3f4276', 'name': 'HUBO'},
      {'uuid': 'b79c4e57-3e54-4d00-bc02-4af9f6052992', 'name': 'Humanic'},
      {'uuid': 'd733ce8b-92e9-4d6a-8e50-830ef331d649', 'name': 'Hush Puppies'},
      {'uuid': '1a4a131a-c9d0-44bb-915e-5e5ba9db6c03', 'name': 'HUSK'},
      {'uuid': '45d30391-8699-4d24-8421-387693a30aed', 'name': 'Huttopia [V2]'},
      {'uuid': '604c6ef5-53cb-431d-9903-80034fb05f84', 'name': 'IBERICUS (PTM F) [V2]'},
      {'uuid': '2bc3b147-3e3a-44b9-a8f8-d111aa8122ae', 'name': 'Ici Paris XL'},
      {'uuid': 'abba003a-ab01-4ea6-be97-44913abcf93f', 'name': 'Icicle'},
      {'uuid': 'a3d5f11c-8ba5-4b8e-a204-07fbb5a4052a', 'name': 'IDF Belgium (PTM) [V2]'},
      {'uuid': '7ae888a5-9c63-4649-b1df-ed484ebcd348', 'name': 'III VIVINIKO'},
      {'uuid': '84f0450c-a070-4b8c-97ad-2ad6f365fa06', 'name': 'Immochan [V2]'},
      {'uuid': 'e4f2fcbc-7a1c-49be-9a07-62fbfbdbe303', 'name': 'Infoway'},
      {'uuid': 'b5365f7e-6d0d-407d-9488-8c1ca4a4e8f4', 'name': 'Ingos Musik Test [V2]'},
      {'uuid': '29ec6ef2-1837-4631-91b2-a8761a14aee5', 'name': 'INNO (Galleria)'},
      {'uuid': '5d61f0ab-e1f2-4cb1-b4aa-a1dd8706dc15', 'name': 'IntercityHotel '},
      {'uuid': 'f95a7b70-6a08-470b-a178-8e327089589f', 'name': 'IntercityHotel GEMA'},
      {'uuid': 'ca2ef79c-26a2-4d87-a51b-387d08baf7e0', 'name': 'Intermede'},
      {'uuid': '1e9e7560-a6f9-4dda-bbe1-6fcdd9e4aeec', 'name': 'InterSky Luftfahrt GmbH'},
      {'uuid': 'e7d75fe0-66bc-4010-b843-cf580ec3246b', 'name': 'InterSport'},
      {'uuid': '7e1d2d54-c28e-4afe-bc3a-52420133d4a4', 'name': 'INTERSPORT  (PTM) [V2]'},
      {'uuid': 'd5f247d9-c84f-472f-a42a-6600056cfc5d', 'name': 'Intersport France (CC) [V2]'},
      {'uuid': '65ef1012-b4f9-48bb-a917-6ac5c60d9ed5', 'name': 'ISERIES'},
      {'uuid': '38290188-2e3c-4547-81ad-ecb620eb31ad', 'name': 'IWC'},
      {'uuid': 'ee42d698-66f1-4863-84b6-a6c9223fb8a9', 'name': 'IXINA'},
      {'uuid': 'afeb54ee-1714-4b5b-921a-4e83c16abb26', 'name': 'IXINA (PTM) [V2]'},
      {'uuid': '61085eb0-334c-4956-9035-d88f54ac5e63', 'name': 'Ixina china'},
      {'uuid': 'a0d738a1-1b80-4ea1-8d3d-e3a93656b84f', 'name': 'J.M. Weston'},
      {'uuid': 'a47573fe-43ea-416a-bd5b-922c71defc21', 'name': 'Jaeger LeCoultre'},
      {'uuid': 'ad091114-dca5-42bf-89f7-983f94830253', 'name': 'Jamendo'},
      {'uuid': '932e4ec3-da4c-4bf6-be21-74f6dad47e8a', 'name': 'JamStream'},
      {'uuid': 'f61d7051-d0f4-49e8-8dac-950120a3c95e', 'name': 'Jaquet Droz'},
      {'uuid': '524712fb-3844-46a1-aa0a-c67ad1e25c71', 'name': 'JBC [V2]'},
      {'uuid': '8646765e-221a-4043-b380-a906f4c6acdd', 'name': 'JDV'},
      {'uuid': '8450408f-f4ed-4558-957e-6319b1c75c46', 'name': 'Jean Louis David'},
      {'uuid': '876df57c-b22b-47db-908e-63ec63954c3c', 'name': 'Jean Louis David (PTM) [V2]'},
      {'uuid': '8e44f3e0-edfa-4a63-b2ef-1aeadc25282a', 'name': 'Jean Louis David Spain'},
      {'uuid': '43a7eb73-899a-4a84-be71-2e609e1ddc9e', 'name': 'Jennyfer'},
      {'uuid': 'f2f19e56-0530-43a2-92a3-d53894afa592', 'name': 'JLM Prod'},
      {'uuid': '19bde08f-5d66-44db-8970-fee8853ea65d', 'name': 'Jones Lang LaSalle'},
      {'uuid': '37c9be5a-b7d6-4776-acc6-4d08f95386c9', 'name': 'Jorge Vazquez [V2]'},
      {'uuid': '51386916-dee0-4de1-9eff-a8ab9cea1d4e', 'name': 'Jott'},
      {'uuid': '8d79207d-2667-422a-81fd-bbe7f824d649', 'name': 'JoueClub'},
      {'uuid': '36d7e2c5-4226-4721-99d7-c0c8c4882ff6', 'name': 'Jubei'},
      {'uuid': 'e838bb1f-a4bf-469c-9d88-6a6be7704100', 'name': 'JULIEN D ORCEL'},
      {'uuid': '0ecb6d70-0608-494b-aaba-aa78d7fecf17', 'name': 'Jumex '},
      {'uuid': 'c6677907-86b9-4a47-b8a4-3d6faa35e377', 'name': 'Justinian Video Room'},
      {'uuid': '61c47e9d-0178-495e-a2f4-7e7cbc7b25c6', 'name': 'K&L Ruppert'},
      {'uuid': 'd8c25cf2-ba5d-4f74-9c18-8826003ab15c', 'name': 'KABB '},
      {'uuid': '1f694484-01bd-4a95-b073-6a401b7c2a22', 'name': 'KALICO (PTM F) [V2]'},
      {'uuid': 'e2fb6509-b6d3-404b-ac72-19619d11571b', 'name': 'Kamps Bäckerei'},
      {'uuid': '80bcd71f-28e1-46f5-aa68-4261d3b213e9', 'name': 'Kamps Backstube'},
      {'uuid': 'daafae5c-c9f9-4b83-a798-20f790b9ae7d', 'name': 'KAPORAL [V2]'},
      {'uuid': '0d50da83-bd45-477e-98d8-e795cd303f05', 'name': 'KENGEE'},
      {'uuid': '8fff510d-85c4-45e6-b665-5f8a0c7c62e6', 'name': 'Kienast'},
      {'uuid': 'da483148-af65-4601-a249-e76aeaf23f4d', 'name': 'Kik '},
      {'uuid': '9fcec99a-02b0-4617-b0db-0154f0ad8c02', 'name': 'King Marcel [V2]'},
      {'uuid': '3f774668-8906-4e57-be66-f2661ff56020', 'name': 'Kinopolis'},
      {'uuid': 'b31615f3-1e68-415d-a62e-1319b4dd664c', 'name': 'Klepierre'},
      {'uuid': 'd965d64c-12ff-492a-ae88-ba111dc5d039', 'name': 'Klépierre'},
      {'uuid': 'e97023c3-8bf5-42bd-86a1-5385b289fe89', 'name': 'KLEPIERRE FRANCE [V2]'},
      {'uuid': 'bb4d4043-b7da-4a86-bc61-9e6795d69ccc', 'name': 'KMG(Germany)'},
      {'uuid': 'b2405b77-1375-4ac8-9519-a6f57b2cf07c', 'name': 'Knauf (PTM) [V2]'},
      {'uuid': '8a22dbcd-1f92-4859-85f8-f47cf2457f6c', 'name': 'KNIGHT FRANK'},
      {'uuid': '0936bf1b-58c6-472d-b7c2-2685cbe815be', 'name': 'Kookaï'},
      {'uuid': '950d462a-d3e3-4266-85c7-c1f89676770d', 'name': 'Kraemer'},
      {'uuid': 'cf8652f9-d356-439e-a659-1cbb04dfc354', 'name': 'Kraemer China'},
      {'uuid': 'aa7365bd-c597-4300-8419-1b7969ebfef9', 'name': 'Kress Mode'},
      {'uuid': '6be3a85a-0711-4891-a0f8-5bbbf92caaa6', 'name': 'Krys [V2]'},
      {'uuid': '487edde8-137d-4584-8682-9bf7a110eea0', 'name': 'KuLeChaoWan'},
      {'uuid': '93e4ec4b-7fce-4f42-acd1-fb2c6617968a', 'name': 'L2'},
      {'uuid': '42a2d93b-8ec6-485c-bc19-33d64844fcf9', 'name': 'LA BOUCHERIE (PTM F) [V2]'},
      {'uuid': '03c91d54-153e-4301-967f-71f01cc1ffbf', 'name': 'La Chapelle test'},
      {'uuid': 'd534a80f-7d55-4e75-aacb-d289b9070e46', 'name': 'La Chapelle test soft'},
      {'uuid': '7560a004-7005-478f-8c50-a74fdc524279', 'name': 'La Halle aux Vêtements'},
      {'uuid': '23affae3-c1f7-445f-8e71-ecd10fe98fc7', 'name': 'La maison du convertible [V2]'},
      {'uuid': 'da858856-b2cf-4b5e-9a13-f0ea0c1fc594', 'name': 'La Paniere'},
      {'uuid': '3790f127-ce48-4955-9291-d0cabb328d77', 'name': 'La Pataterie [V2]'},
      {'uuid': '44db7247-f84d-4563-91c0-fa2cfee4f294', 'name': 'La Poste'},
      {'uuid': '9e173242-52ca-4d6c-b079-e0d900d60a5b', 'name': 'Lachapelle'},
      {'uuid': '31755b35-ec63-4a7d-af6d-f5bb5637497e', 'name': 'Lady Fitness'},
      {'uuid': '5bbb939f-79d4-404c-97c7-3b234db7deb5', 'name': 'LAIYINFEN '},
      {'uuid': 'bd14ef6a-ed25-4810-a814-f879c3cdb33f', 'name': 'Lalique Paris'},
      {'uuid': '4b70189e-cd55-4786-92f2-a0d48696b62d', 'name': 'Lancel'},
      {'uuid': '6f6f69b8-74f8-4a65-9ba9-ba0b7f370c23', 'name': 'Lange & Söhne'},
      {'uuid': '2191dd62-1ebf-4fda-b18c-8dc338d4b5de', 'name': 'Lascana'},
      {'uuid': '608be69c-d9ea-4d39-993e-9f026912bf5f', 'name': 'Laurel'},
      {'uuid': 'd6da9382-328a-4f6d-9c06-98357ca5198e', 'name': 'LD COIFF (PTM) [V2]'},
      {'uuid': 'a53a7927-791c-4678-8835-13a389c877cd', 'name': 'Le Crobag'},
      {'uuid': '907fb5c4-efc3-4350-9f54-08f6b8eddec0', 'name': 'Le Grand Comptoir'},
      {'uuid': 'e40a303c-776b-4d1e-a850-033f8af4c232', 'name': 'Le Pain Quotidien'},
      {'uuid': '7c2011e5-9bbe-4287-8106-8381532e18d3', 'name': 'Le Pain Quotidien México [V2]'},
      {'uuid': '46c72156-5a03-4678-8d27-2eb665c71d64', 'name': 'Leader Price'},
      {'uuid': '71179f27-a299-46e0-a79f-80ad5f810b1e', 'name': 'Leica'},
      {'uuid': '5d54e24d-3fc3-45b4-99ab-f585bdae2de4', 'name': 'Leon de B. [V2]'},
      {'uuid': 'edc5cfa3-15ce-44f4-93ef-76d2190fce72', 'name': 'Leon de Bruxelles'},
      {'uuid': '6667c9e8-9ea3-4565-8bb5-864082cd0b2b', 'name': 'Leonidas'},
      {'uuid': 'b7c5f8ce-e3ec-480d-9b5a-3688de63e506', 'name': 'Leonidas France'},
      {'uuid': '1bfdc98c-df68-44e7-b0cd-ee5b96ddcd47', 'name': 'LES JARDINS DU MESNIL [V2]'},
      {'uuid': '9fca0dc9-c9fb-4f5d-aae3-60471a29ab67', 'name': 'Liberty Gym'},
      {'uuid': '130b0536-1609-41f9-9b14-145e74743cc4', 'name': 'Lick'},
      {'uuid': '9df9220e-f498-4d98-b356-a84b79f1816e', 'name': 'LIDL FRANCE'},
      {'uuid': '8447d44e-e1b2-41af-9bb8-ec5111ed270d', 'name': 'Lidl Spain'},
      {'uuid': '11469b83-5edf-41c4-8bb8-9914fbcca650', 'name': 'Linctex'},
      {'uuid': 'b6e9b3af-7da0-4556-aae0-a004755bbf38', 'name': 'LinoSA'},
      {'uuid': 'bcd55a3d-d35e-43ba-8a56-9a19250df197', 'name': 'Lissac'},
      {'uuid': '30c6e323-0390-406b-aa4c-b71f1fb0e92b', 'name': 'Little Extra [V2]'},
      {'uuid': 'da96bb1e-7fde-445f-86b5-d924f04e7911', 'name': 'Lladro (PTM F) [V2]'},
      {'uuid': 'ee01e0c6-7403-4f39-96e9-4b187b9386f0', 'name': 'Loding'},
      {'uuid': 'e5385677-5b78-4b1d-ac91-2ca5fe4c49b5', 'name': 'Lola Liza [V2]'},
      {'uuid': '2ad4594f-a564-4434-9702-d1e7703c15c8', 'name': 'Longchamp Paris'},
      {'uuid': '60649ffe-af63-42bf-88e4-4cfac2426615', 'name': 'Louis Delhaize [V2]'},
      {'uuid': 'fec1ed51-3ce2-4f01-9a73-3dfa77582663', 'name': 'Loxam Belgique'},
      {'uuid': '0b3ad0e8-87b9-4a0d-9928-0c4d78578b96', 'name': 'Loxam France'},
      {'uuid': '0c681adb-1cb8-4438-a596-b93caea9f32f', 'name': 'Lucie Saint-Clair [V2]'},
      {'uuid': '4112d71c-2afb-4713-86a7-c4bdf25e5f7f', 'name': 'Lufthansa German Airlines'},
      {'uuid': '3a86ecf7-3cc8-48da-b8c1-6a61eb09d1e3', 'name': 'Lumas'},
      {'uuid': '92820f73-8e84-432a-a095-950ca8c240eb', 'name': 'Lunch Garden [V2]'},
      {'uuid': '46c292a2-66f7-41cb-95c0-c2498875059d', 'name': 'LuoLai'},
      {'uuid': '71593fd6-d71a-4886-87de-214d6090600d', 'name': 'Madison'},
      {'uuid': 'b854de37-8be9-4b2e-a689-e9dedcbaba0a', 'name': 'Maille [V2]'},
      {'uuid': 'befab861-4276-4c58-8503-53c4c27c8877', 'name': 'Maison Brémond 1830 [V2]'},
      {'uuid': '7a903ad4-95bd-4f3a-8d91-0264ea41c44a', 'name': 'Maison DEGAND (PTM) [V2]'},
      {'uuid': 'ffa0c9f3-3224-4bc8-b660-3089b9ce71c6', 'name': 'Mall inside kunming'},
      {'uuid': 'e98a253c-9d24-4b03-a1ef-598eeca85a2b', 'name': 'Mall outside Kunming'},
      {'uuid': '7c542a8e-ae50-45be-afb2-bdbca271a563', 'name': 'Maniet - Luxus'},
      {'uuid': '450fa511-6b66-4592-bb52-e8c2a764134d', 'name': 'Marc Cain '},
      {'uuid': '4fa6e69e-05bf-469e-8f81-f1b7c72fcd79', 'name': 'Marc Video Room'},
      {'uuid': '17fbd81f-6894-4d4a-b55b-f7c1ade80f0a', 'name': 'Marcolini'},
      {'uuid': '70512e0d-29af-47eb-b307-716bb4353371', 'name': 'Marella'},
      {'uuid': '53567a73-c552-4008-af3d-1e6d4b72a645', 'name': 'Marie Morrie'},
      {'uuid': 'fb131fc1-fe24-49f8-a37e-54f296a38315', 'name': 'Marionnaud España'},
      {'uuid': 'bb01db16-04e9-45ff-ae48-61f1b9f193cd', 'name': 'Marionnaud France [V2]'},
      {'uuid': '986a21e6-58e0-4b01-8357-8482020f6b77', 'name': 'Markfairwhale Jeans'},
      {'uuid': '06235329-8f0f-4c7a-883a-cdcf2ba7939d', 'name': 'Match BELUX'},
      {'uuid': '80d7a0b3-7bfd-44c1-a2b9-79ff59b9333d', 'name': 'Match FRANCE'},
      {'uuid': '4acacaac-80d2-42ac-a96c-883bbae3ccd0', 'name': 'Maty'},
      {'uuid': 'da95e166-b27f-4edc-9d95-dbb0698fda7e', 'name': 'Mavi'},
      {'uuid': 'e89065d0-1294-4c4f-89e6-fc622d430d22', 'name': 'Max Mara'},
      {'uuid': '2c0e5200-2b96-473e-9431-fc3acc8e03fa', 'name': 'MAXI TOYS (Jamendo) [V2]'},
      {'uuid': 'ac417ec2-e6af-4fef-9109-160b66816196', 'name': 'Mayerline'},
      {'uuid': '158ce558-a40b-40c8-b478-4e1f5fbb23eb', 'name': 'Me & City FLAG SHIP new'},
      {'uuid': 'cd9e79b8-7260-4a1e-b99e-21e8e12308df', 'name': 'Me & City Flag Ship Store'},
      {'uuid': '0c074574-c22b-4bbd-acc7-745c5bee05a3', 'name': 'ME&CITY'},
      {'uuid': '3666007b-7a9b-47f9-a5a4-6d60923630a6', 'name': 'Mellow Yellow'},
      {'uuid': 'ea1b9008-202b-4888-84a9-679055f6e7b2', 'name': 'MELVIN (PTM)'},
      {'uuid': 'd6280af0-1188-4548-a886-9e4e167d4716', 'name': 'Mephisto'},
      {'uuid': '5a37ee3f-a0f9-4856-9009-e92075454452', 'name': 'Mercedes'},
      {'uuid': 'df0e89b7-3060-41fc-b50d-54cd9226dfb9', 'name': 'Merkal (PTM F) [V2]'},
      {'uuid': '5e62cb0c-2cb2-4c54-a0b1-22d8aa385183', 'name': 'Metersbonwe'},
      {'uuid': '8b933aaa-b7d8-4e1f-aecf-1d75d0f1b354', 'name': 'Mezzo Di Pasta'},
      {'uuid': 'd9e5cb5a-0841-44ef-8a3f-d4d96f0cca42', 'name': 'Minelli'},
      {'uuid': '92b32a9c-be3c-4336-87c9-a9abe11de7c4', 'name': 'Minette/Hotwind'},
      {'uuid': '585a8162-bafa-485f-aa09-dab5224f5c43', 'name': 'MIXX'},
      {'uuid': '2cd0cd8d-cbd3-40df-aac6-68b07fe2520d', 'name': 'MOA'},
      {'uuid': 'c68142cd-4e86-480a-8727-136e1016f354', 'name': 'Mobistar'},
      {'uuid': '4910e551-26c8-43a8-9d99-809b76b49ca3', 'name': 'Modehaus Fischer'},
      {'uuid': '348a7f32-2616-4119-9b5a-ff70d7b1b72f', 'name': 'Mondial Moquette'},
      {'uuid': '8dd65a59-3903-4614-89ee-5b8ba8c83246', 'name': 'Monoprix'},
      {'uuid': '8436c3d4-3922-4f04-98b9-11a917744e35', 'name': 'Montblanc'},
      {'uuid': 'f6c800f0-d3e6-49e6-af24-f15550c9a80d', 'name': 'MU'},
      {'uuid': '7422fce0-b01b-47a3-a0d6-07b4318d0cad', 'name': 'Multipharma [V2]'},
      {'uuid': 'a8f1a44f-f3b5-46e4-ae20-5a1c1f4bb8b7', 'name': 'Mumuso Basic'},
      {'uuid': '9546130b-2f2d-49a9-9d2e-84b5911f191e', 'name': 'MusicMatic China'},
      {'uuid': '7bb5967c-4332-414b-89c0-54e6318bef3d', 'name': 'MusicMatic Germany'},
      {'uuid': 'f73a33d7-8dd8-4dbe-ac75-fc6d009ce007', 'name': 'Mustang'},
      {'uuid': 'eeea50df-2ffe-4708-a621-2f9085ae1ff6', 'name': 'My Little Store [V2]'},
      {'uuid': 'b5c69872-4840-42ec-a6d4-f3eedd1816f0', 'name': 'Naf Naf'},
      {'uuid': 'd2d9d133-c9f9-43a3-afca-8cb69e51174d', 'name': 'Nahman'},
      {'uuid': 'b678fa49-ad10-4bbf-bd7c-985cde99e01b', 'name': 'Nana s Tea'},
      {'uuid': 'c9b8f8dc-275a-4d13-b610-8008e69987d9', 'name': 'Nanu-Nana'},
      {'uuid': '405c6425-b48d-413e-9132-fed8d9ce4bf8', 'name': 'NATURALIA [V2]'},
      {'uuid': 'efd530a4-b0ed-4162-ba7d-30962b36ef58', 'name': 'Navyboot'},
      {'uuid': '6a133e69-57c8-4dce-a1ef-ab0b72406fd6', 'name': 'Neck&Neck'},
      {'uuid': '0e37e3e2-ecdf-4a29-86cb-7d17df74bf5c', 'name': 'Nenlutea'},
      {'uuid': '2097838d-85ea-42ec-a47d-66d2c264d66e', 'name': 'Neuhaus'},
      {'uuid': '453ea773-a82c-43ec-b4be-b2c2e1e8a62e', 'name': 'New Yorker'},
      {'uuid': '4d8d2aff-7543-44aa-b9e8-9dc4af97b951', 'name': 'New Yorker (Test)'},
      {'uuid': '47475c91-8c46-4a04-8cb4-45ba26e2838a', 'name': 'NICORO'},
      {'uuid': '95c35aaa-f8a7-4807-a5ef-85c4d2b6679a', 'name': 'Nitori'},
      {'uuid': 'b955fa18-5ac1-4dd2-a5a6-91fd24fe89b8', 'name': 'Nitori(ningbo)'},
      {'uuid': 'c0091e87-0437-4321-a11f-28ae3b219b2d', 'name': 'Nocibé '},
      {'uuid': '89ad6862-f11b-4301-9515-dbb77d67a0c1', 'name': 'Norfolk'},
      {'uuid': '46eac3c5-23ec-4d87-b11f-24986e09d483', 'name': 'Nuñez de Arenas (PTM F) [V2]'},
      {'uuid': '5532c762-8d09-4629-a4f9-532be5064892', 'name': 'Obi'},
      {'uuid': 'f63177ec-1e93-4139-823e-830d3b2e242a', 'name': 'Ocean Ground Coffee'},
      {'uuid': '4bedc47d-6734-4435-81e8-0faa99a3c7ac', 'name': 'Odlo'},
      {'uuid': 'b91b7637-056e-4065-be0b-717d0e13129e', 'name': 'Oh!Green (PTM) [V2]'},
      {'uuid': 'e006d8b5-fc43-4d57-a733-dfc489fb228e', 'name': 'Okko Hôtel [V2]'},
      {'uuid': 'da98309a-d473-4d0c-959a-fc267480b69b', 'name': 'Olymp'},
      {'uuid': 'ce3aca99-b96d-4641-8abd-bbc59c472d1e', 'name': 'Omega [V2]'},
      {'uuid': 'a94cda5b-9ee9-40dd-b4e2-bf6a52015e48', 'name': 'ONLY'},
      {'uuid': '6af5da6e-7335-43a5-b1a0-e82ed6ec6a62', 'name': 'OPEL BELGIUM'},
      {'uuid': '757dc7d8-6be6-4941-bf7d-556233917163', 'name': 'Open 25 Piloto Jamendo '},
      {'uuid': '1a43099e-439d-42f3-a489-b3c583c32f19', 'name': 'OPEN 25 PROGRAM'},
      {'uuid': '33bc2977-ab2a-40ac-ad75-ef026d208b44', 'name': 'Orange'},
      {'uuid': '20951f53-8b4a-47dc-8831-42e14c81051a', 'name': 'Origino [V2]'},
      {'uuid': 'd855e0fd-fc3e-4b63-946f-426d209b9fc5', 'name': 'Oro Vivo AG Germany'},
      {'uuid': '123371be-b14f-482d-aed5-e69d2a838b13', 'name': 'Orsay Online'},
      {'uuid': 'b1e27bd9-9255-4509-bd2a-01ea07086268', 'name': 'Osco'},
      {'uuid': 'c409c675-242b-426a-bab7-1a922e9ae762', 'name': 'Overstock - X²O'},
      {'uuid': '8e8ada8b-6da7-4a5b-8122-d36b0c78c122', 'name': 'Oxbow [V2]'},
      {'uuid': '50250ca4-9ada-4cce-a256-e5eb3ab1b692', 'name': 'OXIMI (PTM) [V2]'},
      {'uuid': '8c78f948-3524-4e89-8bab-12def11cc143', 'name': 'PANERAI [V2]'},
      {'uuid': 'a7a79bed-814d-46c8-a211-35aa42fba1e4', 'name': 'Papa jonhs'},
      {'uuid': '4b004981-8bb1-4d90-aff9-7eaf9024daa2', 'name': 'Pappert'},
      {'uuid': 'fe65ba3b-1a39-46dc-8c86-602e85f17aaf', 'name': 'Paprika'},
      {'uuid': '10f9859d-983b-4229-a552-326239e68ca9', 'name': 'Paris Bleu'},
      {'uuid': '506c046d-1fe8-475b-96ea-72e080414a43', 'name': 'Paris Rouge Suzhou'},
      {'uuid': '00b310a0-59a1-43a0-a92a-76a4220dfc20', 'name': 'Park view green'},
      {'uuid': '73b3156a-feee-4404-8f2a-6b1a4a52ced1', 'name': 'Parkson Department store'},
      {'uuid': '34b7a957-854e-43a4-8f42-9b6b48e0a631', 'name': 'PARRONDO [V2]'},
      {'uuid': '56c68788-101c-4ff6-8f4c-f807f505f910', 'name': 'PATHE CINEPOINTCOM (PTM) [V2]'},
      {'uuid': '2ae1e639-a6e4-44e6-b6e8-d345507949dd', 'name': 'Patricia Demo'},
      {'uuid': '058deb0d-844e-4437-960b-bfd5c7b84239', 'name': 'Patricia Radio'},
      {'uuid': '94ee453c-7728-49b0-9314-9da8918e853e', 'name': 'Paul (bakkery)'},
      {'uuid': 'a75f1f54-07d5-4541-bcc2-8690c92b346e', 'name': 'Paul Franck'},
      {'uuid': 'c6cb6535-ab73-4bde-8137-be6005860c8a', 'name': 'Pedro'},
      {'uuid': '8f606ca9-9844-45da-aab6-8a3efc9380f2', 'name': 'Pharmactiv'},
      {'uuid': '3f136526-d234-4689-b2e2-a351dbd89009', 'name': 'Pharmavance (PTM) [V2]'},
      {'uuid': 'a431d498-47fa-4cab-a7cf-a6fbbccff94a', 'name': 'Phildar'},
      {'uuid': '7dac4a81-bcf2-4620-ba1e-57771d55d299', 'name': 'Philipp Plein'},
      {'uuid': 'a16f8872-d6c5-4ec2-a957-097dc426de95', 'name': 'Piaget'},
      {'uuid': '83c9163d-10dc-404d-95e8-f2a8291f608d', 'name': 'Piel de Toro [V2]'},
      {'uuid': '391ba749-c7ec-468b-899a-72ad2f66bd79', 'name': 'Pierre Balmain'},
      {'uuid': '3a7c23a5-3bf2-4421-b329-05e9f674080b', 'name': 'Pimkie '},
      {'uuid': 'aab06fbb-eeee-4956-93cd-1f3c0dd4ca4a', 'name': 'PIZZA DEL ARTE [V2]'},
      {'uuid': 'e690efb7-c87b-480a-a8db-33b15c7a2ee2', 'name': 'Pizza Hut'},
      {'uuid': 'f6c9b9f4-16c5-4245-b936-59945bea35ff', 'name': 'Planet Parfum [V2]'},
      {'uuid': '033ab569-10f1-437d-a38e-bb64dda85e2a', 'name': 'Planet Sports'},
      {'uuid': '317ab43c-bf56-47e5-b41c-0ca7bd0dc9f5', 'name': 'Planet Sushi'},
      {'uuid': '75a430f7-8c12-43a2-b8ed-6e6682c39120', 'name': 'Pomelo'},
      {'uuid': '8a46eabc-0c5d-4a57-9205-626a109ff50c', 'name': 'Pomme de Pain [V2]'},
      {'uuid': 'eb90a08e-c801-4431-a940-670df954511b', 'name': 'Promod [V2]'},
      {'uuid': '5ba8ec3c-9226-423b-8a8f-8c0c9fa8ea94', 'name': 'Proximus'},
      {'uuid': '38b3c03d-7b0e-431c-9824-df8e8f3a7517', 'name': 'PRUEBA AD MANAGER SPAIN - PTM [V2]'},
      {'uuid': '427ae1eb-8e11-47dc-8c92-8f70874a2772', 'name': 'PTM (End Of Life)'},
      {'uuid': '1d66e25f-d63e-463d-b5b0-54374789513f', 'name': 'PTM - Bis (End of Life)'},
      {'uuid': '1912ab55-e601-48ab-8b29-1c5771640790', 'name': 'PTM - Free (End Of Life)'},
      {'uuid': '323cec56-69de-402f-bc93-8b8ed4836ad0', 'name': 'Q-Park'},
      {'uuid': '154138d2-d2a3-4602-b039-4adaefb833f6', 'name': 'Rado [V2]'},
      {'uuid': '5caba79b-ecfe-4497-aab0-2045a701ff33', 'name': 'Ray'},
      {'uuid': '36f2ee70-9fb6-4a4c-9b79-cdef88d1cab4', 'name': 'Red Pharma'},
      {'uuid': '90e9fb72-8144-4ae2-839d-f051bb0aec40', 'name': 'Red Pharma Beta'},
      {'uuid': '35e9bb3e-1eaa-43a0-baef-5284b54d91f1', 'name': 'REDPHARMA (PTM) [V2]'},
      {'uuid': '506a41b8-68bd-4f05-9f78-db324f10ac6d', 'name': 'Reel department store'},
      {'uuid': '95544413-cea6-4c75-8bc8-ef71af6d49ef', 'name': 'Renault'},
      {'uuid': '9f73a74a-4890-4863-b4d8-3013c1f1babc', 'name': 'Ricardo Video Room'},
      {'uuid': '0bb9706c-fb3a-443a-832e-5b23c7386795', 'name': 'Richter+ Frenzel '},
      {'uuid': 'e463262c-0f33-48ad-9e42-700d27eb1f8f', 'name': 'Rituals'},
      {'uuid': '0cf07298-19cd-49d2-804c-b54bf99dce11', 'name': 'Rodier'},
      {'uuid': '7e5a256b-38ea-42d3-b70a-55d666566a3e', 'name': 'ROGER DUBUIS [V2]'},
      {'uuid': 'b4020d13-bdc6-4058-9dc6-49f71a662450', 'name': 'Rombouts'},
      {'uuid': '28667af9-47da-4a3b-aee3-8607e0ebe83e', 'name': 'Rouge Gorge'},
      {'uuid': '51538834-9d58-4af3-8095-1f1326e039fb', 'name': 'Sabon [V2]'},
      {'uuid': '4715b19c-3037-4278-8657-f08e599c36c6', 'name': 'Saga Cosmetics [V2]'},
      {'uuid': '99e36383-4d87-4c61-bee6-2a639d09e9ee', 'name': 'Sagasser'},
      {'uuid': 'cb91e5ce-7190-44ec-ba82-77bd825b94ad', 'name': 'Saint Algue'},
      {'uuid': '6d0d2174-22ce-49c1-a15e-7c9b8e933055', 'name': 'San Marina'},
      {'uuid': '6877d742-fcbb-4d91-a43c-394f423679b0', 'name': 'Sarah Pacini'},
      {'uuid': 'd9d3dce3-bfdf-4c9d-ba70-e46857164e9a', 'name': 'SCALPERS'},
      {'uuid': '259022b0-1b49-4f9e-80c1-a7e042d6faf4', 'name': 'Scapino'},
      {'uuid': '508ddebb-0d9e-48cb-93d6-213f5cbd9921', 'name': 'Schuhpark'},
      {'uuid': 'a762f9ae-c20e-407a-984d-38c352abb0ee', 'name': 'Secret recipe'},
      {'uuid': 'af2eacbe-cc3e-4c37-99d6-7f3b646a531b', 'name': 'SEGECE'},
      {'uuid': '82652aa8-bb9c-461d-b2ba-766e82a3fa3b', 'name': 'Sehne (PTM F) [V2]'},
      {'uuid': '3a382b57-9a09-42a9-8162-22b8a149fb0b', 'name': 'Semir '},
      {'uuid': '236c0136-190d-45ef-9187-f15201b1c2b9', 'name': 'Sephora Chine'},
      {'uuid': '773a2137-352a-49f7-a896-caa623783d61', 'name': 'Sephora FR'},
      {'uuid': 'f94091e3-f069-41c5-8c2c-fe78511440e8', 'name': 'Sequoia (PTM) [V2]'},
      {'uuid': '30cb8ad8-412a-4d85-a73f-5d514732dfc1', 'name': 'Sergent Major Chine'},
      {'uuid': 'a6373773-f118-4a29-9ffa-cfdeeaae0633', 'name': 'Sharmoon'},
      {'uuid': 'a4cc1bff-4715-4499-9bfe-d5113e540a82', 'name': 'sheego'},
      {'uuid': 'dcbb103b-d4f5-44ba-b171-d1e38a9fd821', 'name': 'Sherpa'},
      {'uuid': '4957d7de-14a5-447f-9d40-1a87468fbab4', 'name': 'SHOPPING LES BASTIONS  (PTM) [V2]'},
      {'uuid': 'ef23b41d-d2b6-4663-9f0a-cbb5acef0f1b', 'name': 'Shopping Olen (PTM) [V2]'},
      {'uuid': '7aa013fc-466b-4b0e-9b81-7a692e583152', 'name': 'Silomon (PTM) [V2]'},
      {'uuid': '126673ab-fde8-4112-ba76-1dbbc78e57ff', 'name': 'Simone Perele'},
      {'uuid': '8d1516e6-54a2-4fdd-8c5f-79802ef2220a', 'name': 'Sinequanone'},
      {'uuid': 'af668273-2cb9-494a-b0b2-53d74566e2a2', 'name': 'Six'},
      {'uuid': '108492ad-7259-40b8-bba9-5304d7a23ea5', 'name': 'SMCP'},
      {'uuid': 'c96ba5ff-fc44-4a91-941b-0d4a7dece30c', 'name': 'Snipes'},
      {'uuid': 'acaec6f8-5590-4195-be69-536a9a4066cb', 'name': 'SOCOOC [V2]'},
      {'uuid': '84587d3f-f636-4246-8a2e-a4cfe2de8470', 'name': 'sodexo'},
      {'uuid': 'f685949e-54cc-4e68-a141-ce4aa5a35594', 'name': 'Soleil Sucré'},
      {'uuid': 'ddcd3214-4282-4751-80c5-80f9cacba745', 'name': 'Sonnenklar'},
      {'uuid': '8ec71221-8e22-4c9a-a3b7-6a87a542818a', 'name': 'SPA china'},
      {'uuid': 'a0fc3944-40b7-4698-af1f-d2ef255f2b04', 'name': 'SPINN (PTM) [V2]'},
      {'uuid': '56caceb4-5220-4b57-b577-6a9a2e05424c', 'name': 'Stadthausgalerie (PTM) [V2]'},
      {'uuid': '4211460a-c70e-4fe6-818c-1f076c32c2c6', 'name': 'Steigenberger [V2]'},
      {'uuid': '48a7e4a1-d57c-4039-9f9a-374b1c5b16c0', 'name': 'Steigenberger Hotel Dortmund [V2]'},
      {'uuid': 'b0ff6ac4-3b13-47e3-b56b-6f01e1c268f2', 'name': 'Stella Luna'},
      {'uuid': '1de57f6e-fc12-4adf-b72f-52f7d0fc36bf', 'name': 'Stella Luna Shoes'},
      {'uuid': '4402ea9d-81fc-4c13-8735-c4504e853877', 'name': 'Stop Services'},
      {'uuid': '47c837fe-9e93-4b84-a9f7-966e08b25880', 'name': 'Storever [V2]'},
      {'uuid': '0f034dc2-9859-4f2a-9a98-a5d134162387', 'name': 'Storever Internal'},
      {'uuid': '24b92ed4-9ff2-4889-af2b-d1d855767a24', 'name': 'StreamIt'},
      {'uuid': '3b956058-25e4-4b4d-a11d-17f2f8a4c46f', 'name': 'Subway'},
      {'uuid': '0237294a-5736-466d-8469-f84301d116af', 'name': 'SUITEHOTEL'},
      {'uuid': '1e527b9b-6f80-45ee-9f45-925df502f846', 'name': 'SUKIYA [V2]'},
      {'uuid': '65b7a2dc-e412-44be-9053-c1cab42aca6e', 'name': 'Super Dry [V2]'},
      {'uuid': '231fc7b8-1787-41c1-95b0-b8878ac7414d', 'name': 'SWATCH CHINA'},
      {'uuid': '4187915f-cbcd-486a-8215-8d2a9b0f5ef8', 'name': 'Swatch China Inter'},
      {'uuid': 'cdde33cc-b330-494d-b58b-c11a7dfd5dbe', 'name': 'SWATCH HQ'},
      {'uuid': '740f01ca-87b8-4c77-a39c-7514a4df2d8d', 'name': 'Tati '},
      {'uuid': '50c5e255-727a-4f25-bdef-4175f9bfba07', 'name': 'TEC - Jamendo'},
      {'uuid': '39d60ce7-6e1a-4cab-87ed-047e6323e262', 'name': 'Telekom'},
      {'uuid': '896aed7e-7195-4d57-a44b-4717b2c805cc', 'name': 'Temp Paris'},
      {'uuid': '549b6455-003c-440e-b215-6d5f8b65be68', 'name': 'Test Baudouin'},
      {'uuid': 'c3b369c7-b781-4741-84eb-478393196149', 'name': 'TEST CHINA'},
      {'uuid': 'cc1e8433-c48a-4699-84e4-52a7bcebd938', 'name': 'The Land'},
      {'uuid': '6f41c8d3-aff4-4191-b670-f14c33af1e05', 'name': 'The Swatch Group [V2]'},
      {'uuid': '21c78773-b354-4c31-a3f6-e9425e353653', 'name': 'Thomas Sabo '},
      {'uuid': '0344a970-9d93-4cbf-8fad-645ebf96870e', 'name': 'TINO GONZÁLEZ'},
      {'uuid': '1bc4eab6-06f4-49ab-9406-7fc95708ff6b', 'name': 'Tissot [V2]'},
      {'uuid': 'fb8ae8e0-4982-4657-970f-6127a2f9406b', 'name': 'Tom And Co  [V2]'},
      {'uuid': 'fe66b8a1-c2de-46e7-9ee9-e6244780cf85', 'name': 'tony clan'},
      {'uuid': '3c6f7fd0-3e3f-4441-881d-124bebc4b076', 'name': 'Tourbillon'},
      {'uuid': 'fb77a77c-ed73-4c73-8f01-9f76d09e2211', 'name': 'Touring Assurances [V2]'},
      {'uuid': 'd953e259-4646-4090-8af9-6308c7d1b818', 'name': 'Toy R Us Iberia'},
      {'uuid': '5acc84d8-b95b-4f50-9a0b-33c31483d78c', 'name': 'Toys R us'},
      {'uuid': 'f5417664-0094-4388-906d-96e2d0dd8f0c', 'name': 'TRAFIC [V2]'},
      {'uuid': '788af3c3-6044-4344-b5d3-b75f823dc5fe', 'name': 'Training Room Belgique [V2]'},
      {'uuid': '881162b5-fd78-41cc-8f22-e5659c8bf5e3', 'name': 'Training Room China [V2]'},
      {'uuid': 'cc7152fb-9035-4928-9967-529954900bd0', 'name': 'Training Room France [V2]'},
      {'uuid': 'ba43110d-5045-46d5-9ec3-c7768cd511c2', 'name': 'Training Room Germany [V2]'},
      {'uuid': 'b1c3525c-e472-4aa2-be6b-4ffe74d04f66', 'name': 'Training Room Spain [V2]'},
      {'uuid': 'b24a8e18-c9db-4b9d-80ca-5b511edb01e6', 'name': 'Uno De 50'},
      {'uuid': 'd4cf8e8e-a0da-4dbc-b3d0-8879722a07d5', 'name': 'Vacheron Constantin'},
      {'uuid': '79f0ba25-804c-4e78-863c-1bcafd1cc283', 'name': 'Van Cleef  Arpels'},
      {'uuid': 'ff59a61d-bf42-44fb-96e3-23b8638aea40', 'name': 'Van Laack'},
      {'uuid': '92fc092c-6d1c-400b-927a-f4af6fda4d14', 'name': 'Vandenborre Kitchen (PTM) [V2]'},
      {'uuid': '6ec30896-fc05-4056-8a1d-aaa421361e8c', 'name': 'VEGA PLAZA (PTM) [V2]'},
      {'uuid': 'fbbd748f-ad87-4520-a062-2f44907961a3', 'name': 'VOLVO FRANCE (PTM) [V2]'},
      {'uuid': 'f31ed0b2-52bc-4250-9561-520237bb84b2', 'name': 'Walbusch'},
      {'uuid': '54980d51-afd2-4b9f-b66d-ef277ee81727', 'name': 'Wasbar [V2]'},
      {'uuid': 'a6032a04-6077-442d-9418-4491a9e2da4b', 'name': 'WASBAR (PTM) [V2]'},
      {'uuid': '674054f8-8f10-45c2-b5f1-e04bc9850ef5', 'name': 'wcloset'},
      {'uuid': '138ad9aa-bb61-4e5e-926c-c46f85b8643e', 'name': 'WEI retreat'},
      {'uuid': '9b37d711-ff29-4290-96ee-c505c782ad48', 'name': 'Wereldhave'},
      {'uuid': '88708175-762f-4840-a21e-6bddf9fa56e9', 'name': 'Wöhrl'},
      {'uuid': '4189735c-a238-4c69-813a-51b57a5f7097', 'name': 'Wolford'},
      {'uuid': 'd0a34007-35b4-436e-8360-5cfc3d2ff983', 'name': 'Woluwe Shopping'},
      {'uuid': '9e245a91-a663-4c56-97ca-84155c33fb6c', 'name': 'Yanlord'},
      {'uuid': '6b62dd0d-3fb0-41f0-bc0f-5d3a67628093', 'name': 'YUMMY'},
      {'uuid': '5deae9bd-011a-42af-9851-b87b347a67ea', 'name': 'Zambala Spain PTM F [V2]'},
      {'uuid': '8d46c429-ac08-4536-8f5a-f8896a3f98cd', 'name': 'Zenith Angle'},
      {'uuid': 'd79e5393-e769-482f-8b32-3ccbbe4f9295', 'name': 'Zero'},
      {'uuid': 'f88df08c-0173-4278-b335-0718fbcc51dc', 'name': 'Zodio'},
      {'uuid': '7b15d263-139c-4cf9-9db4-ea0da0a7b572', 'name': 'ZucZug'}
    ],
    'count': 566
  },
  'log': null,
  'version': '1.0.1.18'
}

export const CLIENT_NOT_EMPTY_NEW_STRUCTURE_PRODUCT =  {
      'cName': 'ad_proxy_delhaize' + Math.floor(Math.random() * 1000) + 1 ,
      'office': 1,
      'sales':  {
        'uuid': 'c0c06e09-2669-42ce-af33-a0ba7cb82096',
        'name': 'Emilie Rahm'
      },
      'server': true,
      'services': [
        {
          'enable': true,
          'producerUuid': '84da4466-ca4f-4c1d-8bc3-842d9e3b1eca',
          'serviceID': 1,
          'products': [
            {
              'selected': true,
              'canCheck': false,
              'id': 1,
              'name': 'MM-BOX AUDIO',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 2,
              'name': 'MM-BOX AUDIO (Mini)',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': false,
              'id': 5,
              'name': 'MM-BOX PTL',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 6,
              'name': 'MM-USB AUDIO',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 7,
              'name': 'MM-SOFT AUDIO',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 12,
              'name': 'CD AUDIO',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 13,
              'name': 'AUDIO FILES',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 16,
              'name': 'STREAM',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            }
          ],
          'applications': [
            {
              'enable': false,
              'customized': false,
              'id': 4,
              'name': 'ADManager'
            }
          ],
          'options': {
            'licence': [
              {
                'selected': true,
                'canCheck': true,
                'id': 1,
                'name': 'Commercial'
              },
              {
                'selected': true,
                'canCheck': true,
                'id': 2,
                'name': 'Jamendo'
              },
              {
                'selected': false,
                'canCheck': true,
                'id': 3,
                'name': 'SoundReef'
              }
            ],
            'program': [
              {
                'selected': true,
                'canCheck': true,
                'id': 1,
                'name': 'Tailormade'
              },
              {
                'selected': false,
                'canCheck': true,
                'id': 2,
                'name': 'Mainstream'
              }
            ],
            'cd': false
          },
          'volume': null,
          'id': 1128,
          'name': 'Audio'
        },
        {
          'enable': true,
          'producerUuid': 'c38a9541-0394-4a8d-9f1d-bceed5f0c64b',
          'serviceID': 2,
          'products': [
            {
              'selected': true,
              'canCheck': true,
              'id': 4,
              'name': 'MM-BOX AUDIO VIDEO 2 OUT',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 14,
              'name': 'MM-BOX SMIL II Pro',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 18,
              'name': 'MM-BOX DS PLAYER VIDEO 4K',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 19,
              'name': 'MM-BOX DS SMART SIGNEBOARD 10',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 20,
              'name': 'MM-BOX DS SMART SIGNEBOARD 10 TOUCH',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            },
            {
              'selected': false,
              'canCheck': true,
              'id': 21,
              'name': 'MM-BOX DS SMART SIGNEBOARD 21',
              'network': true,
              'proxy': true,
              'wifi': true,
              'cd': true
            }
          ],
          'applications': [
            {
              'enable': true,
              'customized': false,
              'id': 2,
              'name': 'DSManager'
            }
          ],
          'options': {
            'widget': [
              {
                'selected': false,
                'canCheck': true,
                'id': 1,
                'name': 'Creator'
              },
              {
                'selected': false,
                'canCheck': true,
                'id': 2,
                'name': 'Weather'
              },
              {
                'selected': false,
                'canCheck': true,
                'id': 3,
                'name': 'Instagram (Beta)'
              },
              {
                'selected': true,
                'canCheck': true,
                'id': 4,
                'name': 'Youtube'
              },
              {
                'selected': false,
                'canCheck': true,
                'id': 5,
                'name': 'Form'
              },
              {
                'selected': false,
                'canCheck': true,
                'id': 6,
                'name': 'Pdf'
              }
            ]
          },
          'volume': 6,
          'id': 634,
          'name': 'Video'
        }
      ],
      'allowedUsers': false,
      'loginLimit': 6,
      'isProspect': true,
      'parentUuid': '47c837fe-9e93-4b84-a9f7-966e08b25880',
      'uuid': 'bf37431a-92ba-429c-bb6c-cec1a08b7c5c',
      'created': '2015-03-27T14:58:10.17+01:00',
      'updated': '2019-01-15T15:12:49.9+01:00',
      'id': 171,
      'name': 'AD PROXY Delhaize'
  };
